export default "__VITE_ASSET__BqeF73m4__"